import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Lojistik } from 'src/model/lojistik';
import { RestService } from 'src/providers/rest.service';

@Component({
  selector: 'app-lojistik-liste',
  templateUrl: './lojistik-liste.component.html',
  styleUrls: ['./lojistik-liste.component.css']
})
export class LojistikListeComponent implements OnInit {

  lojistikler: Lojistik[] = null;

  @Input()
  public set source(lojistikler: Lojistik[]) {
    if (lojistikler != null) {
      this.lojistikler = lojistikler;
    }
  }
  constructor(private router: Router, private restApi:RestService) { }

  ngOnInit() {
  }

  sil(id:number){
    this.restApi.deleteLojistik(id).subscribe(res=>{
      this.restApi.getLojistikler(0, 0, null, '')
      .subscribe(res => {
        this.lojistikler = res.results;
      });
    })
  }

  incele(l: Lojistik) {
    this.router.navigate(['rota-olustur'], { queryParams: { id: l.id } });
  }

  degisimGecmisi(l:Lojistik){
    this.router.navigate(['rota-gecmis'], { queryParams: { id: l.cariId } });
  }

  rotaFiyat(id: number) {
    this.router.navigate(['lojistik-rota-fiyatlar'], { queryParams: { id: id } });
  }

  IrsaliyeFiyat(id:number){
    this.router.navigate(['irsaliye-lojistik-rota-fiyat'], { queryParams: { id: id } });
  }
}
